import React, { useEffect , useState } from "react";
import container from "../../../../styles/Global.module.css";
import {
  statusReadyLeads,
  typeReadyLeadsSupply,
} from "../../../../json/StatusOptions.js";
import ColumnStatus from "../../../../components/global/fields/ColumnStatus.jsx";
import EditableText from "../../../../components/global/fields/EditableText.jsx";
import SingleDuration from "../../../../components/global/fields/SingleDurationDatePicker.jsx";
import BaseBoard from "../../../global/BoardTemplate/BaseBoard.jsx";
import { GridLogicOperator } from "@mui/x-data-grid-pro";
import { useCustomState } from "../../../../utils/useCustomState.js";
import ThreadListModal from "../../../Threads/components/ThreadListModal.jsx";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ReadyLeadsSupply = () => {
  const apiUrl = `${backendUrl}/api/ready-leads-supply/items`;
  const apiUsers = `${backendUrl}/api/users?populate[0]=role`;
  const userStorageEmail = localStorage.getItem("email");
  const [hopManagement, setHopManagement] = useState(null);  
  
  const [state, updateState] = useCustomState({
    groups: ["Ready leads supply"],
    status: "",
    users: [],
    items: [],
    selectionRow: [],
    updateRows: [],
    columnsFilter: { id: false },
    viewFilter: {
      items: [],
      quickFilterLogicOperator: GridLogicOperator.Or,
    },
    pinnedColumns: {
      left: ["__check__", "threads"],
      right: [],
    },
  });

  useEffect(() => {
    const fetchApi = async () => {
      const resUsers = await fetch(apiUsers);
      const data = await resUsers.json();

      setHopManagement(data.filter((user) => user.role.name === "hop-management")[0].email ?? null);

      updateState({ users: data });
    };

    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterItemsAndSetGroups = (items) => {
    updateState({ items });
  };

  const handleEditResponseChange = async (newValue, rowID, field) => {
    const updatedRowsNoTerminados = state.items.map((row) => {
      if (+row.id === +rowID) {
        return { ...row, [`${field}`]: newValue };
      }
      return row;
    });
    updateState({ items: updatedRowsNoTerminados });
  };

  const getGroupRows = (groupName) => {
    return groupName === "Ready leads supply" ? state.items : [];
  };

  const updateBoard = (newData) => {
    const updatedRows = [...state.updateRows, newData];

    updateState({ updateRows: updatedRows });
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      headerAlign: "center",
      align: "center",
    },

    {
      field: "threads",
      headerName: "Thread",
      width: 70,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        return <ThreadListModal {...params} />;
      },
    },
    {
      field: "company",
      headerName: "Company",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"company"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.company}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "website",
      headerName: "Website",
      width: 180,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"website"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.website}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "contact",
      headerName: "Contacto",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"contact"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.contact}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"email"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.email}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "sellerId",
      headerName: "Seller ID",
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"sellerId"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.sellerId}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "type",
      headerName: "Type",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",

      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"type"}
          columnPosition={280}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={typeReadyLeadsSupply}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",

      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"status"}
          columnPosition={280}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={statusReadyLeads}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "firstContact",
      headerName: "First contact",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <SingleDuration
          {...params}
          selectionRow={state.selectionRow}
          fieldKey="firstContact"
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "statusDetailed",
      headerName: "Status detailed date",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"statusDetailed"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.statusDetailed}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
    {
      field: "lastConvo",
      headerName: "Last convo",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"lastConvo"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.lastConvo}
          disabled={params.row.owner?.email === userStorageEmail ? false : hopManagement === userStorageEmail ? false : true}
        />
      ),
    },
  ];

  return (
    <div className={container.globalContainer}>
      <BaseBoard
        columns={columns}
        groups={state.groups}
        getGroupRows={getGroupRows}
        setGroupItems={filterItemsAndSetGroups}
        apiUrl={apiUrl}
        status={state.status}
        setStatus={(status) => updateState({ status })}
        updateBoard={updateBoard}
        updateRows={state.updateRows}
        setSelectionRow={(selectionRow) => updateState({ selectionRow })}
        selectionRow={state.selectionRow}
        setViewFilter={(viewFilter) => updateState({ viewFilter })}
        viewFilter={state.viewFilter}
        columnsFilter={state.columnsFilter}
        setColumnsFilter={(columnsFilter) => updateState({ columnsFilter })}
        pinnedColumns={state.pinnedColumns}
        setPinnedColumns={(pinnedColumns) => updateState({ pinnedColumns })}
        checkboxSelection={true}
        height={"80vh"}
        maxHeight={"80vh"}
      />
    </div>
  );
};

export default ReadyLeadsSupply;
